/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PrivacyMode {
    Disabled = 0,
    Automatic = 1,
    Manual = 2,
}
